// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-image-selector-container {
  width: 800px;
}
.ai-image-selector-container .option input[type=radio] {
  display: none;
}
.ai-image-selector-container .option {
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 20px;
}
.ai-image-selector-container .option:hover {
  border: 2px solid #ccc;
}
.ai-image-selector-container .option.selected {
  border: 2px solid #0084ff;
}
.ai-image-selector-container .ai-image-selector-content {
  display: flex;
  flex-wrap: wrap;
  padding: 30px 24px 30px 24px;
  background: #fefefe;
  border: 1px solid #e8ecef;
  border-radius: 12px;
}
.ai-image-selector-container .ai-image-selector-buttons {
  display: flex;
  flex: 1 1;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
}
.ai-image-selector-container .ai-image-selector-button {
  margin-left: 10px;
}
.ai-image-selector-container .ai-image-selector-content p {
  padding: 6px 16px 6px 16px;
  font-size: 14px;
}
.ai-image-selector-container .ai-image-selector-divisor {
  border-top: 1px solid rgba(0, 0, 0, 0.1019607843);
  padding-top: 50px;
}
.ai-image-selector-container .ai-image-selector-active {
  border: 2px solid #0084ff;
  border-radius: 20px;
  padding: 4px 16px 6px 14px !important;
  color: #141718;
  font-weight: 600;
}
.ai-image-selector-container .ai-image-selector-element {
  cursor: pointer;
}
.ai-image-selector-container .ai-image-selector-disabled {
  opacity: 0.6;
  cursor: no-drop;
}
.ai-image-selector-container .ai-image-selector-content h4 {
  font-weight: 600;
  letter-spacing: 0.5px;
}
.ai-image-selector-container .ai-image-selector-content .form-group {
  margin-bottom: 0px;
}
.ai-image-selector-container .ai-image-selector-content .form-group label {
  color: #141718;
}`, "",{"version":3,"sources":["webpack://./src/Components/AiImageSelector/aiimageselector.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,aAAA;AACJ;AAEE;EACE,eAAA;EACA,6BAAA;EACA,mBAAA;AAAJ;AAGE;EACE,sBAAA;AADJ;AAIE;EACE,yBAAA;AAFJ;AAKE;EACE,aAAA;EACA,eAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAHJ;AAME;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,iBAAA;AALJ;AAQE;EACE,0BAAA;EACA,eAAA;AANJ;AASE;EACE,iDAAA;EACA,iBAAA;AAPJ;AAUE;EACE,yBAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,gBAAA;AARJ;AAWE;EACE,eAAA;AATJ;AAYE;EACE,YAAA;EACA,eAAA;AAVJ;AAaE;EACE,gBAAA;EACA,qBAAA;AAXJ;AAcE;EACE,kBAAA;AAZJ;AAeE;EACE,cAAA;AAbJ","sourcesContent":[".ai-image-selector-container {\n  width: 800px;\n\n  .option input[type=\"radio\"] {\n    display: none;\n  }\n\n  .option {\n    cursor: pointer;\n    border: 2px solid transparent;\n    border-radius: 20px;\n  }\n\n  .option:hover {\n    border: 2px solid #ccc;\n  }\n\n  .option.selected {\n    border: 2px solid #0084ff;\n  }\n\n  .ai-image-selector-content {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 30px 24px 30px 24px;\n    background: #fefefe;\n    border: 1px solid #e8ecef;\n    border-radius: 12px;\n  }\n\n  .ai-image-selector-buttons {\n    display: flex;\n    flex: 1;\n    width: 100%;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-top: 10px;\n  }\n\n  .ai-image-selector-button {\n    margin-left: 10px;\n  }\n\n  .ai-image-selector-content p {\n    padding: 6px 16px 6px 16px;\n    font-size: 14px;\n  }\n\n  .ai-image-selector-divisor {\n    border-top: 1px solid #0000001a;\n    padding-top: 50px;\n  }\n\n  .ai-image-selector-active {\n    border: 2px solid #0084ff;\n    border-radius: 20px;\n    padding: 4px 16px 6px 14px !important;\n    color: #141718;\n    font-weight: 600;\n  }\n\n  .ai-image-selector-element {\n    cursor: pointer;\n  }\n\n  .ai-image-selector-disabled {\n    opacity: 0.6;\n    cursor: no-drop;\n  }\n\n  .ai-image-selector-content h4 {\n    font-weight: 600;\n    letter-spacing: 0.5px;\n  }\n\n  .ai-image-selector-content .form-group {\n    margin-bottom: 0px;\n  }\n\n  .ai-image-selector-content .form-group label {\n    color: #141718;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
